import { Link, Typography } from '@mui/material';

const CopyrightTemplate = (props) => {
  return (
    <Typography variant="body2" color="white" align="center" {...props}>
      Copyright {' ©'}
      <Link href="https://onsolution.app" color="inherit">
        OnEdu - Twons
      </Link>{' '}
      {new Date().getFullYear()}
    </Typography>
  );
};

export default CopyrightTemplate;
